import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';
import { CookiesService } from 'app/shared/services/cookies/cookies.service';

export const authGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> | Promise<boolean> | boolean => {
  const router: Router = inject(Router);
  const auth: OidcClientService = inject(OidcClientService);
  const userSession = inject(UserSessionsService);
  const cookiesService = inject(CookiesService);
  const authSubject = new Subject<boolean>();
  auth.getUserComputed().subscribe({
    next: (user) => {
      const path = next.url.length ? next.url[0].path : 'home';
      if (user) {
        auth.isExpiringComputed().subscribe((expiring) => {
          //possible token expiration; try renewing token after checking if it is expired before rejecting navigation
          if (expiring) {
            auth.isExpiredComputed().subscribe({
              next: (expired) => {
                if (expired) {
                  authSubject.next(false);
                  auth.signIn();
                } else {
                  auth.renewToken().subscribe({
                    next: (user) => {
                      if (user) {
                        userSession._firstName.next(user.profile['given_name']);
                        if (
                          (sessionStorage.getItem('isExistingEmployee') || sessionStorage.getItem('userProfileErrorMsg')) &&
                          cookiesService.getCookie('queryToken')
                        ) {
                          userSession._employeeId.next('-1');
                          userSession._isAdmin.next(false);
                          if (!path.includes('non-employee')) {
                            router.navigate(['non-employee']);
                          }
                        } else if (cookiesService.getCookie('userData') && cookiesService.getCookie('queryToken')) {
                          if (path.includes('non-employee')) {
                            router.navigate(['home']);
                          }
                          userSession.setUserData(JSON.parse(cookiesService.getCookie('userData')));
                        }
                        authSubject.next(true);
                      } else {
                        authSubject.next(false);
                      }
                      // An error can occur if a user does not have an existing session
                      // ie. error: User does not have an existing session and request prompt parameter has a value of 'None'
                    },
                    error: (error) => {
                      authSubject.next(false);
                      auth.signIn();
                    },
                  });
                }
              },
              error: (error) => {
                authSubject.next(false);
                auth.signIn();
              },
            });
          } else {
            userSession._firstName.next(user.profile['given_name']);
            if (
              (sessionStorage.getItem('isExistingEmployee') || sessionStorage.getItem('userProfileErrorMsg')) &&
              cookiesService.getCookie('queryToken')
            ) {
              userSession._employeeId.next('-1');
              userSession._isAdmin.next(false);
              if (!path.includes('non-employee')) {
                router.navigate(['non-employee']);
              }
            } else if (cookiesService.getCookie('userData') && cookiesService.getCookie('queryToken')) {
              if (path.includes('non-employee')) {
                router.navigate(['home']);
              }
              userSession.setUserData(JSON.parse(cookiesService.getCookie('userData')));
            }
            authSubject.next(true);
          }
        });
      } else {
        authSubject.next(false);
        auth.signIn();
      }
    },
    error: (error) => {
      authSubject.next(false);
      auth.signIn();
    },
  });
  return authSubject;
};
